/* Progressive enhancement of Shella's native menu blocks and popup. */
(() => {
  const desktop = window.matchMedia('(min-width: 1025px)');
  let lastOpener;
  const direct = (el, selector) => Array.from(el.children).find(child => child.matches(selector));
  const visible = el => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';

  function init() {
    document.querySelectorAll('.zp-editorial-menu:not([data-zp-ready])').forEach(menu => {
      menu.querySelectorAll('.zp-menu-card').forEach(card => {
        const caption = card.querySelector('.promobox__text-2')?.textContent.trim();
        if (caption) card.querySelectorAll('a').forEach(link => {
          if (!link.textContent.trim()) link.setAttribute('aria-label', caption);
        });
      });
      const panel = menu.querySelector('.menu__panel');
      const topItems = Array.from(panel.children).filter(el => el.classList.contains('menu__item'));
      const records = new Map();
      const back = document.querySelector('[data-zp-menu-back]');
      menu.querySelectorAll('.menu__item--has-children').forEach((item, index) => {
        const link = direct(item, 'a');
        const child = direct(item, '.menu__megamenu, .menu__dropdown, .menu__list');
        if (!link || !child) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'zp-menu-toggle';
        button.setAttribute('aria-label', menu.dataset.toggleLabel + ' ' + link.textContent.trim());
        button.setAttribute('aria-expanded', 'false');
        child.id = 'zp-menu-' + index + '-' + (menu.dataset.jsPositionName || 'main');
        button.setAttribute('aria-controls', child.id);
        link.after(button);
        direct(link, 'i')?.remove();
        // Remove only the utility that hides the native mega panel on desktop.
        child.classList.remove('d-lg-none');
        records.set(item, {link, child, button});
        button.addEventListener('click', event => setOpen(item, desktop.matches && event.detail > 0 ? true : !item.hasAttribute('data-zp-open')));
        link.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown' || event.key === ' ') {
            event.preventDefault();
            setOpen(item, true);
            child.querySelector('a, button')?.focus();
          }
        });
      });
      function updateBack() {
        if (back) back.hidden = desktop.matches || !menu.querySelector('[data-zp-open]');
      }
      function setOpen(item, open) {
        const record = records.get(item);
        if (!record) return;
        if (open) {
          // One sibling group at a time keeps the small-screen menu compact.
          Array.from(item.parentElement.children).filter(el => el !== item).forEach(el => setOpen(el, false));
          item.setAttribute('data-zp-open', '');
        } else {
          item.removeAttribute('data-zp-open');
          item.querySelectorAll('[data-zp-open]').forEach(el => setOpen(el, false));
        }
        record.button.setAttribute('aria-expanded', String(open));
        updateBack();
      }
      function closeAll() { topItems.forEach(item => setOpen(item, false)); }
      menu.addEventListener('zp:menu-close', closeAll);
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const item = event.target.closest('[data-zp-open]');
          if (item && menu.contains(item)) {
            event.preventDefault();
            event.stopPropagation();
            setOpen(item, false);
            records.get(item)?.button.focus();
          }
        }
        if (desktop.matches && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          const item = topItems.find(el => el.contains(event.target));
          if (item && (event.target === records.get(item)?.link || event.target === records.get(item)?.button)) {
            event.preventDefault();
            const step = event.key === 'ArrowRight' ? 1 : -1;
            const next = topItems[(topItems.indexOf(item) + step + topItems.length) % topItems.length];
            closeAll();
            direct(next, 'a')?.focus();
          }
        }
      });
      topItems.forEach(item => {
        let timer;
        item.addEventListener('pointerenter', event => {
          if (desktop.matches && event.pointerType !== 'touch') {
            clearTimeout(timer);
            setOpen(item, true);
          }
        });
        item.addEventListener('pointerleave', () => {
          if (desktop.matches) timer = setTimeout(() => {
            if (!item.contains(document.activeElement)) setOpen(item, false);
          }, 180);
        });
        item.addEventListener('focusout', () => setTimeout(() => {
          if (desktop.matches && !item.contains(document.activeElement) && !item.matches(':hover')) setOpen(item, false);
        }, 0));
      });
      document.addEventListener('pointerdown', event => {
        if (desktop.matches && !menu.contains(event.target)) closeAll();
      });
      if (back) back.addEventListener('click', () => {
        const expanded = Array.from(menu.querySelectorAll('[data-zp-open]'));
        const item = expanded[expanded.length - 1];
        if (item) {
          setOpen(item, false);
          records.get(item)?.button.focus();
        }
      });
      desktop.addEventListener('change', closeAll);
      menu.dataset.zpReady = '';
      updateBack();
    });

    const popup = document.querySelector('.js-popup-navigation');
    if (popup && !popup.dataset.zpFocusReady) {
      popup.dataset.zpFocusReady = '';
      const close = popup.querySelector('[data-js-popup-close]');
      const opener = document.querySelector('.header__btn-menu');
      document.addEventListener('click', event => {
        if (event.target.closest('.header__btn-menu')) {
          lastOpener = event.target.closest('.header__btn-menu');
          lastOpener.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(() => { if (visible(popup)) close?.focus(); });
        }
        if (event.target.closest('.zp-navigation-close')) {
          opener?.setAttribute('aria-expanded', 'false');
          lastOpener?.focus();
        }
      }, true);
      // Shella stops click bubbling and finishes closing after its transition.
      const popupShell = popup.closest('[data-js-popup-name]');
      if (popupShell) {
        let wasOpen = popupShell.classList.contains('show');
        new MutationObserver(() => {
          const open = popupShell.classList.contains('show');
          if (wasOpen && !open) {
            opener?.setAttribute('aria-expanded', 'false');
            requestAnimationFrame(() => lastOpener?.focus());
          }
          wasOpen = open;
        }).observe(popupShell, {attributes: true, attributeFilter: ['class']});
      }
      // Escape is handled per level below; prevent Shella's global keyup
      // handler from closing the whole dialog when only one level was closed.
      popup.addEventListener('keyup', event => {
        if (event.key === 'Escape') event.stopPropagation();
      });
      popup.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !event.defaultPrevented) {
          event.preventDefault();
          close?.click();
        } else if (event.key === 'Tab' && !desktop.matches) {
          const focusable = Array.from(popup.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, [tabindex="0"]')).filter(visible);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault(); last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first?.focus();
          }
        }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

